export default __webpack_public_path__ + "static/media/about1.59af808c.jpg";